import { Component, OnInit } from '@angular/core';
import {AuthService} from '../../../user/services/auth/auth.service';
import {CurrentUserService} from '../../../user/services/current-user/current-user.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  public user;
  constructor(public auth: AuthService, public currentUserService: CurrentUserService) { }
  ngOnInit() {
    this.currentUserService.getCurrentUser().subscribe(user => this.user = user);
  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/layout/components/header/header.component.ts